export default {
  emptyPlaceholder: 'Dateien hierher ziehen und ablegen, um sie hochzuladen.',
  addFile: 'Dateien hinzufügen',
  removeAllFiles: 'Alle Dateien entfernen',
};
